module.exports = __webpack_public_path__ + "sprstatic/img/logo.37e8f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xin/logo.png
// module id = b128
// module chunks = 2